import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const storeCategoryServices = {
  addNewStoreCategory,
  updatedStoreCategory,
  softDeleteRestoreStoreCategory,
  deleteStoreCategory,
  getStoreCategoryList,
};

// Add New Store Category
async function addNewStoreCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStoreCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Store Category
async function updatedStoreCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedStoreCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Store Category
async function softDeleteRestoreStoreCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStoreCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Store Category
async function deleteStoreCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStoreCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Store Category
async function getStoreCategoryList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreCategoryList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreCategoryList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreCategoryList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}